"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("./InputField.scss");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactTextMask = require("react-text-mask");

var _reactTextMask2 = _interopRequireDefault(_reactTextMask);

var _colors = require("../../../constants/colors");

var _InputErrorMessage = require("../InputErrorMessage");

var _InputErrorMessage2 = _interopRequireDefault(_InputErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var rootClass = 'c-InputField';

var InputField =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(InputField, _PureComponent);

  function InputField(props) {
    var _this;

    _classCallCheck(this, InputField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputField).call(this, props));
    _this.InputRef = void 0;

    _this.handleOnFocus = function () {
      _this.setState({
        focus: true
      });
    };

    _this.handleOnBlur = function (e) {
      _this.setState({
        focus: false
      });

      if (_this.props.onBlur !== undefined) {
        _this.props.onBlur(e);
      }
    };

    _this.getErrorClass = function () {
      return _this.props.error ? "".concat(rootClass, "--error") : '';
    };

    _this.getDisabledClass = function () {
      return _this.props.disabled ? "".concat(rootClass, "--disabled") : '';
    };

    _this.getFocusClass = function () {
      return _this.state.focus && _this.props.readOnly !== true ? "".concat(rootClass, "--focused") : '';
    };

    _this.getReadOnlyClass = function () {
      return _this.props.readOnly ? "".concat(rootClass, "--readOnly") : '';
    };

    _this.getPrefix = function () {
      return _this.props.prefix ? _react2.default.createElement("span", {
        className: "".concat(rootClass, "__prefix"),
        id: "".concat(_this.props.name, "__input-prefix"),
        "data-testid": "".concat(_this.props.name, "__input-prefix"),
        onClick: _this.props.masked ? function () {} : _this.focusInput
      }, _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _this.props.prefix,
        color: _colors.doveGrayColor
      })) : null;
    };

    _this.focusInput = function () {
      var input = _this.InputRef.current;

      if (input !== null && input.focus) {
        input.focus();
      }
    };

    _this.focusInputAndOnClick = function () {
      var input = _this.InputRef.current;

      if (input !== null && input.focus) {
        input.focus();
      }

      if (_this.props.onClickIcon) {
        //$FlowFixMe @amanda to fix flow complaining it needs antother argument in the below function
        _this.props.onClickIcon();
      }
    };

    _this.getSuffixClasses = function () {
      var type = _this.props.type;
      return ["".concat(rootClass, "__suffix"), type === 'date' ? "".concat(rootClass, "__suffix--date") : ''].filter(Boolean).join(' ');
    };

    _this.getSuffixIconColor = function () {
      var type = _this.props.type;
      return type === 'date' && _this.state.focus ? _colors.whiteColor : _colors.doveGrayColor;
    };

    _this.getSuffix = function () {
      return _this.props.suffix ? _react2.default.createElement("span", {
        className: _this.getSuffixClasses(),
        id: "".concat(_this.props.name, "__input-suffix"),
        "data-testid": "".concat(_this.props.name, "__input-suffix"),
        onClick: _this.focusInputAndOnClick
      }, typeof _this.props.suffix === 'string' ? _react2.default.createElement("span", null, _this.props.suffix) : _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _this.props.suffix,
        color: _this.getSuffixIconColor(),
        spin: _this.props.spin
      })) : null;
    };

    _this.state = {
      focus: false
    };
    _this.InputRef = _react2.default.createRef();
    return _this;
  }

  _createClass(InputField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          autoComplete = _this$props.autoComplete,
          disabled = _this$props.disabled,
          error = _this$props.error,
          errorMessage = _this$props.errorMessage,
          placeholder = _this$props.placeholder,
          type = _this$props.type,
          name = _this$props.name,
          onChange = _this$props.onChange,
          value = _this$props.value,
          masked = _this$props.masked,
          mask = _this$props.mask,
          pipe = _this$props.pipe,
          pattern = _this$props.pattern,
          readOnly = _this$props.readOnly,
          onKeyPress = _this$props.onKeyPress,
          maxLength = _this$props.maxLength,
          max = _this$props.max;
      var activeClasseNames = [rootClass, this.getErrorClass(), this.getDisabledClass(), this.getFocusClass(), this.getReadOnlyClass()].filter(Boolean).join(' ');
      var inputProps = {
        autoComplete: autoComplete,
        tabIndex: '0',
        className: "".concat(rootClass, "__input"),
        placeholder: placeholder,
        name: name,
        id: name,
        type: type,
        value: value,
        disabled: disabled,
        onChange: onChange,
        onFocus: this.handleOnFocus,
        onBlur: this.handleOnBlur,
        readOnly: readOnly,
        pattern: pattern,
        onKeyPress: onKeyPress,
        maxLength: maxLength,
        max: max
      };
      var classes = activeClasseNames + ' ' + (error ? '' : 'c-InputField--hover');
      return _react2.default.createElement("div", null, _react2.default.createElement(_InputErrorMessage2.default, {
        id: "".concat(name, "ErrorMessage"),
        error: error,
        errorMessage: errorMessage
      }), _react2.default.createElement("div", {
        className: classes
      }, this.getPrefix(), masked ? _react2.default.createElement(_reactTextMask2.default, _extends({
        mask: mask,
        pipe: pipe,
        ref: this.InputRef
      }, inputProps)) : _react2.default.createElement("input", _extends({
        ref: this.InputRef,
        readOnly: readOnly
      }, inputProps)), this.getSuffix()));
    }
  }]);

  return InputField;
}(_react.PureComponent);

InputField.defaultProps = {
  error: false,
  disabled: false,
  placeholder: '',
  type: 'text'
};
exports.default = InputField;